// This file is auto-generated by scripts/set-images-cdn-path.js
// Do not edit this file manually
var IMAGES_CDN_VERSION_PATH = '23.0.8';

export { IMAGES_CDN_VERSION_PATH };
//# sourceMappingURL=config.js.map
